import { Children } from "react";
import CustomLoader from "./customLoader";

export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>{props.text}</h2>
              <p>{props.data ? props.data.paragraph : <CustomLoader />}</p>
              {props?.children}
            </div>
          </div>
          <center className="col-xs-12 col-md-6 align-center">
            {props?.comp}
          </center>
        </div>
      </div>
    </div>
  );
};
